const SET_PER_PAGE = 'SET_PER_PAGE'
const SET_PAGE = 'SET_PAGE'
const SET_IDS = 'SET_IDS'

const state = {
  ids: [],
  page: 1,
  perPage: 10
}

function getIdsSlice (ids, page, perPage) {
  const start = (page - 1) * perPage
  return ids.slice(start, start + perPage)
}

const actions = {
  setPerPage ({ commit }, num) {
    return new Promise((resolve, reject) => {
      commit(SET_PER_PAGE, num)
      resolve()
    })
  },
  setPage ({ commit }, num) {
    return new Promise((resolve, reject) => {
      commit(SET_PAGE, num)
      resolve()
    })
  },
  filterIds ({ commit, state }, ids) {
    commit(SET_IDS, getIdsSlice(ids, state.page, state.perPage))
  }
}

const mutations = {
  [SET_PER_PAGE] (state, num) {
    state.perPage = num
  },
  [SET_PAGE] (state, num) {
    state.page = num
  },
  [SET_IDS] (state, ids) {
    state.ids = ids
  }
}

function createPaginator () {
  return {
    namespaced: true,
    state: {...state},
    actions,
    mutations
  }
}

export function registerPaginator (rootStore, collectionModuleName) {
  rootStore.registerModule([collectionModuleName, 'paginator'], createPaginator())
}



// WEBPACK FOOTER //
// ./src/store/modules/paginator.js